import http from 'plugins/axios';

export default {
  getBatchList(data) {
    return http.post({
      url: '/admin/voteBatch/list',
      data,
      dataType: 'form'
    });
  },
  createBatch(data) {
    return http.post({
      url: '/admin/voteBatch/create',
      data,
      dataType: 'form'
    });
  },
  getAllCoin() {
    return http.get({
      url: '/admin/voteCoin/all'
    });
  },
  enableBatch(batchNo) {
    return http.post({
      url: '/admin/voteBatch/enable',
      data: {
        batchNo
      },
      dataType: 'form'
    });
  },
  disableBatch(batchNo) {
    return http.post({
      url: '/admin/voteBatch/disable',
      data: {
        batchNo
      },
      dataType: 'form'
    });
  },
  updateBatch(data) {
    return http.post({
      url: '/admin/voteBatch/update',
      data,
      dataType: 'form'
    });
  },
  removeBatch(id) {
    return http.post({
      url: '/admin/voteBatch/remove',
      data: {
        id
      },
      dataType: 'form'
    });
  }
};
